// TODO: Remove this file when the /brands API endpoint is ready.
import { Injectable, signal } from '@angular/core';
import { DemoScenario } from './brand.mock-data';

/**
 * Holds the currently selected demo scenario so that BrandResourceDev can read
 * it at subscription time without the scenario leaking into production service APIs.
 *
 * Remove alongside BrandResourceDev and the demo-switcher UI once the real API is wired.
 */
@Injectable({ providedIn: 'root' })
export class BrandDemoScenarioService {
    private readonly _scenario = signal<DemoScenario>('populated');
    readonly scenario = this._scenario.asReadonly();

    setScenario(s: DemoScenario): void {
        this._scenario.set(s);
    }
}
